import React from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import ContactHero from './components/ContactHero';
import ContactMethods from './components/ContactMethods';
import ContactForm from './components/ContactForm';
import LocationInfo from './components/LocationInfo';
import TestimonialsSection from './components/TestimonialsSection';
import AvailabilityStatus from './components/AvailabilityStatus';

const ContactCollaborationGateway = () => {
  return (
    <>
      <Helmet>
        <title>Contact - Collaboration Gateway | CodeShow LapZ</title>
        <meta 
          name="description" 
          content="Connect with CodeShow LapZ for your next project. Premium software development services from Sri Lanka, working globally. Multiple contact methods, quick response times, and transparent availability." 
        />
        <meta name="keywords" content="contact developer, hire full-stack developer, remote developer Sri Lanka, project collaboration, web development services" />
        <meta property="og:title" content="Contact - Collaboration Gateway | CodeShow LapZ" />
        <meta property="og:description" content="Ready to start your next project? Connect with CodeShow LapZ for premium software development services and seamless collaboration." />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="/contact-collaboration-gateway" />
      </Helmet>

      <div className="min-h-screen bg-background">
        <Header />
        
        <main className="pt-16">
          {/* Hero Section */}
          <ContactHero />
          
          {/* Contact Methods */}
          <ContactMethods />
          
          {/* Availability Status */}
          <AvailabilityStatus />
          
          {/* Contact Form */}
          <div id="contact-form">
            <ContactForm />
          </div>
          
          {/* Location Information */}
          <LocationInfo />
          
          {/* Testimonials */}
          <TestimonialsSection />
        </main>
      </div>
    </>
  );
};

export default ContactCollaborationGateway;